import * as React from 'react';
import { Flex, FlexDirection } from 'src/components/Flex/Flex';
import styled from 'styled-components';
import ReactTable, { Column } from 'react-table';
import 'src/ReactTableStyles.css';
import 'react-table/react-table.css';
import { Link } from 'react-router-dom';
import { ErrorMessages, REPORT_ROW_COUNT } from '../Globals/Globals';

const OfferingTableWrapper = styled(Flex)`
  width: 100%;
`;

const StyledReactTable = styled(ReactTable)`
  width: 100%;
  line-height: 1em;
  text-align: left;
`;

interface IViewTableProps {
  views: any[];
  viewAccessor: string;
  nameAccessor: string;
  nameHeader: string;
  idAccessor?: string;
}

export class ViewTable extends React.Component<IViewTableProps> {
  constructor(props: any) {
    super(props);
  }

  public renderColumnWithLink(data: any) {
    return (
      <div>
        <Link
          to={'/offering/' + data.original[this.props.idAccessor ? this.props.idAccessor : 'id']}
        >
          {data.value}
        </Link>
      </div>
    );
  }

  public render() {
    const columns: Column[] = [
      {
        Header: this.props.nameHeader,
        accessor: this.props.nameAccessor,
        Cell: row => this.renderColumnWithLink(row)
      },
      {
        Header: 'Views',
        accessor: this.props.viewAccessor,
        style: { textAlign: 'center' },
        width: 60
      }
    ];

    return (
      <OfferingTableWrapper direction={FlexDirection.column}>
        <StyledReactTable
          data={this.props.views}
          columns={columns}
          defaultPageSize={REPORT_ROW_COUNT}
          className="-striped -highlight "
          noDataText={ErrorMessages.noSolutions}
          showPageSizeOptions={false}
          showPageJump={false}
          showPagination={false}
          showPaginationBottom={false}
          sortable={false}
        />
      </OfferingTableWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ViewsTable/ViewTable.tsx